import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedBackService {
  fbs$: BehaviorSubject<any>;

  constructor(private http: HttpClient) { 
    this.fbs$ = new BehaviorSubject(null);
  }

  sendFeedback(data){
    return new Promise((resolve) => {
    this.http.post("api/data/feedbacks", data)
    .subscribe(
      (response: any) => {
        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          resolve(response)
          console.log(response)
        }
      }, (error: any) => {
        resolve(error)
      }
    );
    })
    

  }
}
